export default __webpack_public_path__ + "static/media/img-09-saksan.5b8707a9.jpg";